import "./OwnerChg.scss";

import Main from "./Components/main";

const OwnerChg = (props, ref) => {
    return (
        <div className="bpl-container">
            <Main />
        </div>
    );
};



export default OwnerChg;
